import { HttpClient, toast } from 'base-app'
import * as API from '../configs/index'
class Insurance {
   static checkInfoVehicle(idNum) {
      return HttpClient.get(`${API.API_CHECK_INFO_BY_ID}${idNum}`, { params: { date: new Date().getMilliseconds() } })
   }

   static getCity() {
      return HttpClient.get(`${API.API_GET_CITI}`, { params: { date: new Date().getMilliseconds() } })
   }

   static getWard() {
      return HttpClient.get(`${API.API_GET_WARD}`, { params: { date: new Date().getMilliseconds() } })
   }

   static getDistrict() {
      return HttpClient.get(`${API.API_GET_DISTRICTS}`, { params: { date: new Date().getMilliseconds() } })
   }

   static createConstract(values) {
      return HttpClient.post(`${API.API_CREATE_CONSTRACT}`, values)
   }

   static createVehicle(values) {
      return HttpClient.post(`${API.API_CREATE_VEHICLE}`, values)

   }
   static updateInsurance(values) {
      return HttpClient.put(`${API.API_UPDATE_INSURANCE}`, values)
   }
   static updateVehicle(values) {
      return HttpClient.put(`${API.API_CREATE_VEHICLE}`, values)
  }
   static getTypeMotor() {
      return HttpClient.get(`${API.API_GET_TYPE}`, { params: { date: new Date().getMilliseconds() } })
   }
   static updateInsurance1(values) {
      return HttpClient.put(`${API.API_UPDATE_CONTRACT}`, values)
   }
   static API_CHECK_NUMBERPLATE(idNum) {
      return HttpClient.get(`${API.API_CHECK_NUMBERPLATE}${idNum}`, { params: { date: new Date().getMilliseconds() } })
   }

   static getManufacturers() {
      return HttpClient.get(`${API.API_GET_MANUFACTURERS}`, { params: { date: new Date().getMilliseconds() } })
   }
   static checkInfoContract(idNum) {
      return HttpClient.get(`${API.API_CHECK_CONTACT}${idNum}`, { params: { date: new Date().getMilliseconds() } })
   }
   static getContract(idNum) {
      return HttpClient.get(`${API.API_GET_CONTRACT}${idNum}`)
   }
   static getFee(idNum) {
      // // console.log(new Date().getMilliseconds())
      return HttpClient.get(`${API.API_GET_FEE}${idNum}`, { params: { date: new Date().getMilliseconds() } })
   }
   static createContact(values) {
      return HttpClient.post(`${API.API_CREATE_CONTACT}`, values)
   }


   static getContact(idNum) {
      return HttpClient.get(`${API.API_GET_CONTACT}${idNum}`)
   }
   static payMentType(id, values) {
      return HttpClient.post(`${API.API_PAY_CONSTRACT}/${id}`, values)
   }

   static completeConstract(values) {
      return HttpClient.put(`${API.API_COMPLETE_CONSTRACT}`, values)
   }

   static getContactById(id, values) {
      return HttpClient.get(`${API.API_GET_CONTACT_BY_CONTRACTID}/${id}`, values)



   }

   static approvedConstract(values) {
      return HttpClient.put(`${API.API_APPROVED_CONSTRACT}`, values)
   }


   static getContractInfo(id) {
      return HttpClient.get(`${API.API_GET_CONSTRACT}/${id}`, { params: { date: new Date().getMilliseconds() } })


   }

   static getContractMotoPendeing() {
      return HttpClient.get(`${API.API_GET_CONSTRACTS_MOTOR_PENDING}`)
   }
   static getContractMotoAllPending() {
      return HttpClient.get(`${API.API_GET_CONSTRACTS_MOTO_ALL}`)
   }


   static gettAllBanks() {
      return HttpClient.get(`${API.API_GET_BANK_COMPANY}`)
   }

   static confirmConstract() {
      return HttpClient.post(`${API.API_CONFIRM_CONSTRACT}`)
   }

   static getContractsMotorAll(values) {
    return HttpClient.get(`${API.API_GET_CONSTRACTS_MOTO_ALL}?${values}`, { params: { date: new Date().getMilliseconds() } })
  }

  static getContractsMotorPers(values) {
      return HttpClient.get(`${API.API_GET_CONSTRACTS_MOTO_PERS}?${values}`, { params: { date: new Date().getMilliseconds() } })
  }

}
export default Insurance

